import { Injectable, inject } from '@angular/core';

import { OnAppInit } from '../bootstrap/bootstrapper.service';
import { AppInfoConfig } from '../client-config/app-info.client-config';
import { ClientConfigService } from '../client-config/client-config.service';
import { PlatformProductMapConfig } from '../core';
import { DslService } from '../dsl/dsl.service';
import { UrlService } from '../navigation/url.service';
import { ProductService } from '../products/product.service';
import { SpeculationDetectionService } from '../speculation-detection/speculation-detection.service';
import { LastKnownProductConfig } from './last-known-product.client-config';
import { LastKnownProductService } from './last-known-product.service';

@Injectable()
export class LastKnownProductBootstrapService implements OnAppInit {
    private readonly config = inject(LastKnownProductConfig);
    private readonly dslService = inject(DslService);
    private readonly lastKnownProductService = inject(LastKnownProductService);
    private readonly appInfoConfig = inject(AppInfoConfig);
    private readonly speculationDetectionService = inject(SpeculationDetectionService);
    private readonly productService = inject(ProductService);
    private readonly clientConfigService = inject(ClientConfigService);
    private readonly urlService = inject(UrlService);
    private readonly platformProductMapConfig = inject(PlatformProductMapConfig);

    onAppInit() {
        if (this.speculationDetectionService.isPrerendering()) {
            this.speculationDetectionService.prerenderActivate$.subscribe(() => this.bootstrap());

            return;
        }

        this.bootstrap();
    }

    private bootstrap() {
        this.dslService.evaluateExpression<boolean>(this.config.enabled).subscribe((isEnabled) => {
            if (!isEnabled) return;

            const lastProduct = this.lastKnownProductService.get();
            const isSingleDomain = this.productService.isSingleDomainApp;
            const currentUrl = this.urlService.current();

            const productName = isSingleDomain ? this.productService.current.name : this.config.product;
            const productPath = isSingleDomain ? this.clientConfigService.getProductPath(productName)?.toLowerCase() : null;
            const path = productPath ? `/${productPath}` : '';

            const fullUrl = isSingleDomain ? `${currentUrl.baseUrl()}/${currentUrl.culture}${path}` : this.config.url;

            const isNewProduct = lastProduct.name !== productName;
            const isNewUrl = lastProduct.url !== fullUrl;

            if (isNewProduct || isNewUrl) {
                const name = productName === 'host' ? this.lastKnownProductService.UNKNOWN : productName;
                this.lastKnownProductService.add({
                    url: fullUrl,
                    name: name,
                    previous: isNewProduct ? lastProduct.name : lastProduct.previous,
                    platformProductId: this.platformProductMapConfig.platformProductMap[name] ?? this.appInfoConfig.product,
                });
            }
        });
    }
}
